import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const humidity_ABOVE: typeof valueTypeRenderers.humidity_ABOVE = {
  label: () => unitConverter.humidityAboveCanopy().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.humidityAboveCanopy().title(),
      render: (n) => unitConverter.humidityAboveCanopy(n).valueAsString(),
    }),
}
